<template lang="pug">
b-card.mb-1(no-body='')
  b-card-header.p-1.text-left(header-tag='header' role='tab')
    b-button.btn.text-left(block='' v-b-toggle.accordion-gamemenu='' variant='primary') {{ $t('ui.game_menu') }}
  b-collapse#accordion-gamemenu(visible=''  role='tabpanel')
    b-card-body
      b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
        b-form-group(:label="$t('ui.content')")
          Tree(:data="gameMenuData" draggable @drag="ondraggame")
            div.tree-node-inner-el.text-dark(slot-scope="{data, store}" v-if="data.text" :class="{ 'tree-active' : !data.is_hidden }")
              div
                span.white-space-initial {{ $t('ui.menulist.' + data.text) }}
              div
                input.pointer.align-middle(type="checkbox" name="gamemenuhidden" v-model="data.is_hidden" :true-value="false" :false-value="true")

        //- .row
        //-   .col
        //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

        div.d-flex.justify-content-between.mb-3
          b-button(type="button" variant="info" size="sm" @click="refreshList")
            i.fa.fa-sync
            span.ml-1 {{ $t("ui.reset") }}
          div
            SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')")
            b-button.ml-2(type="button" variant="info" @click="callSync")
              i.fas.fa-sync-alt
              span.ml-1 {{ $t("ui.sync_all") }}
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { DraggableTree } from "vue-draggable-nested-tree";
import * as th from 'tree-helper'

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    Tree: DraggableTree
  },
  props: {
    siteId: {
      type: Number
    },
    gameMenuList: {
      type: Array
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gameMenuData: [],
      data: null,
      maxLevel: 1,
      gameMenuListDefault: [],
    };
  },
  computed: {
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  mounted() {
    this.gameMenuListDefault = this.gameMenuList;
    this.setGameMenuVal()
  },
  methods: {
    refreshList() {
      this.setGameMenuVal()
    },
    setGameMenuVal() {
      var menuList = this.gameMenuListDefault
      this.gameMenuData = []

      for(var i = 0; i < menuList.length; i++) {
        var json = {}
        json = {
          position: menuList[i].position,
          text: menuList[i].content_id,
          is_hidden: menuList[i].is_hidden,
          theme_content_group: menuList[i].theme_content_group
        }
        this.gameMenuData.push(json)
      }
    },
    ondraggame(node) {
      const {maxLevel} = this
      let nodeLevels = 1
      th.depthFirstSearch(node, (childNode) => {
        if (childNode._vm.level > nodeLevels) {
          nodeLevels = childNode._vm.level
        }
      })
      nodeLevels = nodeLevels - node._vm.level + 1
      const childNodeMaxLevel = maxLevel - nodeLevels
      //
      th.depthFirstSearch(this.gameMenuData, (childNode) => {
        if (childNode === node) {
          return 'skip children'
        }
        // if (!childNode._vm) {
        //   console.log(childNode);
        // }
        this.$set(childNode, 'droppable', childNode._vm.level <= childNodeMaxLevel)
      })
    },
    getGameMenuData() {
      var gameMenuList = this.gameMenuData
      var list = []
      var sequence = 0;

      for(var i = 0; i < gameMenuList.length; i++) {
        var json = {}
        sequence = sequence + 1;
        json = {
          position: gameMenuList[i].position,
          sequence: sequence,
          is_hidden: gameMenuList[i].is_hidden,
          parent_content_id: null,
          content_id: gameMenuList[i].text
        }
        list.push(json)
      }
      return list
    },
    submit() {
      var gameMenuList = this.getGameMenuData();

      let url = config.siteThemeContentEditUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.selectedOperatorID,
        site_id: this.siteId,
        content_details: gameMenuList,
        theme_content_group: "game_menu"
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clickedMenu");
                this.gameMenuListDefault = gameMenuList;
                this.refreshList()
                this.$helpers.showDialog(this.$t("ui.combine.update_game_menu"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                this.handleFailed("update_game_menu", this.feedback.status);
              }
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.handleFailed("update_game_menu", this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    handleFailed: function(tag, status) {
      if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + status), "error");
      this.refreshList();
    },
    callSync() {
      this.$emit("callSync");
    }
  }
};
</script>